module.exports = __webpack_public_path__ + "img/心.24951203.gif";